import React from 'react';
import PropTypes from 'prop-types';

const FieldErrorText = ({ children, hidden }) => {
  return !hidden && <span className="p2p-field-error-text">{children}</span>;
};

FieldErrorText.propTypes = {
  hidden: PropTypes.bool
};

FieldErrorText.defaultProps = {
  hidden: true
};
export default FieldErrorText;
